import axios from 'axios'
import {
    Message
} from 'element-ui'
import router from '../router/index'
import globalSetting from '../../setting.js'
import {
    getToken,
    removeToken,
    removeLogin
} from '@/utils/auth'

let baseURl = '/api'

if(process.env.NODE_ENV === 'production'){
    baseURl = process.env.VUE_APP_HOST_URL
}


// 创建axios实例
const service = axios.create({
    baseURL: baseURl, // api的base_url
    timeout: 30000 // 请求超时时间
})


// request拦截器
service.interceptors.request.use(config => {
    if (config.method === 'get') {
        // 将参数拼接到 URL 地址栏上
        config.params = { ...config.params, ...globalSetting.publicParams };
    } 
    else if (config.method === 'post') {
        // 将参数放入请求体中
        config.data = {
            ...config.data,
            ...globalSetting.publicParams
        };
    }
    if (getToken) {
        config.headers['ACCESS-TOKEN'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.method == 'post') {
        config.headers['Content-Type'] = "application/json";
    }
    if (config.data) {
        if (config.data.code) {
            config.headers['code'] = config.data.code;
        }
    }
    if (config.data) {
        if (config.data.sign) {
            config.headers['sign'] = config.data.sign;
        }
    }
    return config
}, error => {
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const addReg = /guanying.leads.web.add/gi.test(response.config.data)
        if (response.data.Status == 'Failed' && !addReg) {
           Message.error(response.data.ErrMsg);
        }
        return response.data;
    }, error => {
        // promt.clear();
        return Promise.reject(error)
    })

export default service